import { CONTACT_EMAIL } from "@/config";
import NidraMark from "./NidraMark";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-[#171512]/10">
      <NidraMark className="bottom-[-45%] right-[-3%]" />
      <div className="relative mx-auto grid max-w-6xl gap-12 px-6 py-16 sm:grid-cols-3">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#171512]/45">Contact</p>
          <a
            data-testid="footer-email-link"
            href={`mailto:${CONTACT_EMAIL}`}
            className="mt-4 block font-mono text-sm tracking-[0.12em] text-[#171512] transition-colors duration-200 hover:text-[#B9822E]"
          >
            {CONTACT_EMAIL}
          </a>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#171512]/45">Legal</p>
          <div className="mt-4 flex flex-col gap-2">
            <a
              data-testid="footer-privacy-link"
              href="/privacy"
              className="font-mono text-sm tracking-[0.12em] text-[#171512]/65 transition-colors duration-200 hover:text-[#B9822E]"
            >
              Privacy Policy
            </a>
            <a
              data-testid="footer-terms-link"
              href="/terms"
              className="font-mono text-sm tracking-[0.12em] text-[#171512]/65 transition-colors duration-200 hover:text-[#B9822E]"
            >
              Terms and Conditions
            </a>
          </div>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#171512]/45">Nostos</p>
          <p className="mt-4 font-mono text-sm tracking-[0.12em] text-[#171512]/35">
            nostos.in / All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
